import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { KForm } from "./KForm";
import { Modal } from "react-bootstrap";
import { KButton, KBUTTON_SIZE, KBUTTON_VARIANT } from "./KButton";
import { blurApp } from "./commons";
export var KModalVariant;
(function (KModalVariant) {
    KModalVariant["primary"] = "primary";
    KModalVariant["warning"] = "warning";
    KModalVariant["danger"] = "danger";
    KModalVariant["success"] = "success";
    KModalVariant["secondary"] = "secondary";
    KModalVariant["transparent"] = "transparent";
})(KModalVariant || (KModalVariant = {}));
export var KModalBackdrop;
(function (KModalBackdrop) {
    KModalBackdrop["simple"] = "simple";
    KModalBackdrop["static"] = "static";
})(KModalBackdrop || (KModalBackdrop = {}));
export var KModalSize;
(function (KModalSize) {
    KModalSize["sm"] = "sm";
    KModalSize["lg"] = "lg";
    KModalSize["xl"] = "xl";
})(KModalSize || (KModalSize = {}));
export const KModal = ({ show, dark = false, variant = "primary", header, onHide, closeButton = true, backdrop = KModalBackdrop.simple, buttonText = "Close", footer, formStuff, size, children, centered, }) => {
    const content = (_jsxs(_Fragment, { children: [_jsx(Modal.Body, { children: children }), _jsx(Modal.Footer, { children: footer ? footer : _jsx(KButton, { onClick: onHide, size: KBUTTON_SIZE.sm, variant: KBUTTON_VARIANT.secondary, text: buttonText, style: { minWidth: 200 } }) })] }));
    useEffect(() => {
        blurApp(show);
    }, [show]);
    return (_jsxs(Modal, { show: show, onHide: onHide, size: size, dialogClassName: `${dark ? "kmodal kmodal-dark" : "kmodal kmodal-light"} ${variant}`, backdrop: backdrop === KModalBackdrop.simple ? true : backdrop, centered: centered, children: [_jsx(Modal.Header, { closeButton: closeButton, children: _jsx(Modal.Title, { children: header ? header : _jsx("span", { children: "\u00A0" }) }) }), formStuff ? (_jsx(KForm, { onSubmit: formStuff.onSubmit, options: formStuff.options, onSubmitting: formStuff.onSubmitting, children: content })) : (content)] }));
};
